<template>
	<div
		class="popup-wrapper"
		v-click-outside="popupClickOutsideHandler"
		v-if="footprintTypes.length"
	>
		<button @click.prevent="popupVisibilityToggle">Add</button>
		<transition name="fade">
			<div
				class="popup-container"
				v-if="popupVisibility">
				<div
					v-for="singleType of footprintTypes"
					:key="singleType.id"
					class="single-type"
					@click.prevent="handleOnClickRedirect(singleType)"
				>
					{{ singleType.label }}
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
const mockData = [
	{
		id: 0,
		type: 'groupA',
		label: 'Group A - Planets',
	},
	{
		id: 1,
		type: 'groupB',
		label: 'Group B - Houses',
	},
	{
		id: 2,
		type: 'groupC',
		label: 'Group C - Rulers',
	},
	{
		id: 3,
		type: 'groupD',
		label: 'Group D - Angular Key Ruler',
	},
	{
		id: 4,
		type: 'groupE',
		label: 'Group E - Element Signs Emphasis',
	},
  {
    id: 5,
    type: 'groupF',
    label: 'Group F - Stelliums'
  },
  {
    id: 6,
    type: 'groupG',
    label: 'Group G - Angular Major Sun Moon'
  },
  {
    id: 7,
    type: 'groupH',
    label: 'Group H - Planet in 12th'
  },
  {
    id: 8,
    type: 'groupI',
    label: 'Group I - Vocational Areas'
  }
]

export default {
	props: {
		itemsGroups: {
			required: true,
			type: Object
		}
	},
	name: "FootprintTableAddButton",
	data() {
		return {
			popupVisibility: false,
			footprintTypes: mockData
		}
	},
	mounted() {
		//TODO add real API call
		// this.footprintTypes = SolFileAPIInstance.getFootprintCategories()
	},
	methods: {
		popupVisibilityToggle() {
			this.popupVisibility = !this.popupVisibility;
		},
		popupClickOutsideHandler() {
			this.popupVisibility = false
		},
		handleOnClickRedirect(data) {
			const newItemData = {
				selectValues: {...this.itemsGroups[data.type]},
				group: data.type,
				label: data.label
			}
			this.$router.push({
				name: 'Add new Footprint',
				params: newItemData
			})
		}
	}
}
</script>

<style scoped lang="scss">

.fade-enter-active, .fade-leave-active {
	transition: opacity .5s;
}

.fade-enter, .fade-leave-to {
	opacity: 0;
}

.popup {

	&-wrapper {
		position: relative;

		button {
			margin: 0 !important;
		}
	}

	&-container {
		background-color: #ECF4F6;
		box-shadow: 1px 0 6px 1px #decece;
		right: 0;
		left: auto;
		position: absolute;
		min-width: 300px;
		text-align: right;
		border: 1px solid #ccc;
		border-radius: 5px;
		padding: 10px;
		margin-top: 10px;
		z-index: 999;

		.single-type {
			margin: 5px 0;
			padding: 5px;
			cursor: pointer;
			transition: .4s ease all;
			border-radius: 5px;

			&:hover {
				color: white;
				background-color: #ccc;
			}
		}
	}
}

</style>